export const MODULE_NAME = 'notification';

// --- Real-time notification hub (own SignalR connection) ---

// Path appended to the configured `signalRUrl` base for the notification
// connection (mirrors the Vue `${signalrHub}/notificationhub`).
export const NOTIFICATION_HUB_PATH = '/notificationhub';

// Server -> client event carrying a new notification.
export const HUB_EVENT_NOTIFICATION_ADDED = 'NotificationAdded';

// Client -> server methods.
export const HUB_METHOD_JOIN_GROUP = 'JoinGroup';
export const HUB_METHOD_CLOSE_NOTIFICATION = 'CloseNotification';

// Window event re-broadcasting a received notification to UI listeners
// (mirrors the Vue `$notificationHub.$emit('notification-added')`).
export const NOTIFICATION_ADDED_EVENT = 'notification-added';
